<!--TODO - extract which actions are visible to facade-->
<div class="toolbar-container">
  @if (hasSave && !requisition.archivedAt) {
    @if (!isFormPristine) {
      {{ 'app.offer_form.unsaved_changes' | translate }}
    }
    @if (isFormPristine) {
      @if (requisition.updatedAt === requisition.createdAt) {
        <span>
          {{ 'app.offer_form.nothing_to_save' | translate }}
        </span>
      } @else {
        @if (!isOlderThanHour()) {
          <span class="just-saved">{{
            'app.common.just_saved'
              | translate: { updatedAt: requisition.updatedAt | rtTimeAgoAsync }
          }}</span>
        } @else {
          {{ 'app.offer_form.last_edit' | translate }}
          {{ requisition.updatedAt | rtTimeAgoAsync }}
        }
      }
    }
  }
  @if (requisition.archivedAt) {
    {{ 'app.requisitions.archived' | translate }} {{ requisition.archivedAt | rtTimeAgoAsync }}
  }

  <div layout margin-left-auto>
    @if (hasApproverActions) {
      <rt-button variant="success" (click)="approveRequest.emit()" margin-right-small>
        <rt-icon name="check"></rt-icon>
        <span>{{ 'app.requisitions.actions.approve' | translate }}</span>
      </rt-button>
      <rt-button
        variant="error"
        (click)="rejectRequest.emit()"
        [attr.margin-right-small]="hasManageActions || null"
      >
        <rt-icon name="block"></rt-icon>
        <span>{{ 'app.requisitions.actions.reject' | translate }}</span>
      </rt-button>
    }

    @if (!requisition.archivedAt) {
      @switch (requisition.status) {
        @case (RequisitionStatus.Draft) {
          <ng-container [ngTemplateOutlet]="defaultButtonsTpl"></ng-container>
        }
        @case (RequisitionStatus.Rejected) {
          <ng-container [ngTemplateOutlet]="defaultButtonsTpl"></ng-container>
        }

        @case (RequisitionStatus.Pending) {
          @if (hasManageActions && !hideManageActionsUnderMore) {
            <rt-button (click)="cancelRequest.emit()" margin-right-small>
              <rt-icon name="cancel"></rt-icon>
              {{ 'app.requisitions.actions.cancel_request' | translate }}
            </rt-button>
          }
        }

        @case (RequisitionStatus.Approved) {
          @if (canCreateJob) {
            <rt-button variant="primary" (click)="createJob.emit()" margin-right-small>
              <rt-icon name="add"></rt-icon> {{ 'app.offers.new_job' | translate }}
            </rt-button>
          }
        }

        @case (RequisitionStatus.Filled) {
          @if (hasManageActions) {
            <rt-button (click)="archive.emit()" margin-right-small>
              <rt-icon name="archive"></rt-icon> {{ 'app.offers.archive' | translate }}
            </rt-button>
          }
        }
      }
    }

    @if (hasManageActions) {
      <rt-icon-button
        #moreDropdownTrigger="rtOverlayOrigin"
        variant="outline"
        (click)="moreDropdown.open = !moreDropdown.open"
        rt-overlay-origin
        iconName="more-horiz"
        shape="square"
        [disabled]="hasManageActionsDisabled"
        [pressed]="moreDropdown.open"
      >
      </rt-icon-button>
      <ng-template
        [origin]="moreDropdownTrigger"
        [width]="230"
        (backdropClick)="moreDropdown.open = false"
        #moreDropdown="rtConnectedOverlay"
        rt-connected-overlay
        hasBackdrop
      >
        <rt-dropdown [width]="DropdownWidth.Small">
          @if (hideManageActionsUnderMore && requisition.status === RequisitionStatus.Pending) {
            <rt-dropdown-item (click)="cancelRequest.emit()">
              <rt-icon prefix name="cancel"></rt-icon>
              {{ 'app.requisitions.actions.cancel_approval_request' | translate }}
            </rt-dropdown-item>
          }
          @if (!requisition.archivedAt) {
            <rt-dropdown-item (click)="duplicate.emit()">
              <rt-icon prefix name="content-copy"></rt-icon>
              {{ 'app.offers.duplicate' | translate }}
            </rt-dropdown-item>
          }
          @if (requisition.status !== RequisitionStatus.Filled && !requisition.archivedAt) {
            <rt-dropdown-item (click)="archive.emit()">
              <rt-icon prefix name="archive"></rt-icon>
              {{ 'app.offers.archive' | translate }}
            </rt-dropdown-item>
          }
          @if (requisition.archivedAt) {
            <rt-dropdown-item (click)="retrieve.emit()">
              <rt-icon prefix name="unarchive"></rt-icon>
              {{ 'app.requisitions.actions.retrieve' | translate }}
            </rt-dropdown-item>
          }
          @if (!requisition.offersCount) {
            <rt-dropdown-item (click)="delete.emit()">
              <rt-icon prefix name="delete"></rt-icon>
              {{ 'app.common.delete' | translate }}
            </rt-dropdown-item>
          }
        </rt-dropdown>
      </ng-template>
    }
  </div>
</div>

<ng-template #defaultButtonsTpl>
  @if (hasManageActions) {
    @if (hasSave) {
      <rt-button [disabled]="hasManageActionsDisabled" (click)="save.emit()" margin-right-small>
        {{ 'app.common.save_changes' | translate }}
      </rt-button>
    }
    <span
      [rtTooltip]="requestApprovalButtonDisabledMessage"
      [rtTooltipEnabled]="requestApprovalButtonDisabled"
      [rtTooltipMaxWidth]="240"
      [rtTooltipHasTextAlignCenter]="true"
    >
      <rt-button
        [disabled]="requestApprovalButtonDisabled || hasManageActionsDisabled"
        variant="primary"
        (click)="requestApproval.emit()"
        margin-right-small
      >
        <rt-icon name="send"></rt-icon>
        {{ 'app.requisitions.actions.request_approval' | translate }}
      </rt-button>
    </span>
  }
</ng-template>
